import ky from 'ky';

const restApi = ky.create({
    prefixUrl: '/api',
});

export default restApi;
